// Definición de defaults

export const defaultTipoConvenio: TipoConvenioProps = {
    idTipoConvenio:     0,
    descripcion:        '',
    activo:             false,
}

// Creación de interfaces

export interface TipoConvenioProps   {
    idTipoConvenio:     number;
    descripcion:        string;
    activo:             boolean;
}